import { GETv2Quote } from '@/api/quotes';

export const getForexLists = async () => {
  try {
    const res = await GETv2Quote({ type: 'TRMAIN', column: 'F_FORMAT' });

    return res?.data?.items || [];
  } catch (e) {
    console.log(`外匯跑馬API錯誤`);
    return [];
  }
};
